import { TreeNode } from '@farris/ui-treetable';
import { LookupGridComponent } from '../lookup-grid.component';
import { TreeInfo } from '../lookup-grid-options';

export class TreeNodeHelper {
    treeInfo: TreeInfo;
    flatAllNodes = [];
    constructor(private instance: LookupGridComponent) { }

    getTreeInfo(treeNode: TreeNode) {
        if (treeNode.data[this.treeInfo.dataField]) {
            return treeNode.data[this.treeInfo.dataField];
        }

        const data = treeNode.data;
        if (data && this.treeInfo.dataField) {

            const treeInfoDataField = this.treeInfo.dataField.toLowerCase();
            const dataField = Object.keys(treeNode.data).find(n => {
                return n.toLowerCase() === treeInfoDataField;
            });
            if (dataField) {
                return data[dataField];
            } else {
                this.instance.writeConsole(`æªæ¾å°æ å½¢ä¿¡æ¯æ°æ®å­æ®µã${this.treeInfo.dataField}ã`, 'error');
            }
        } else {
            this.instance.writeConsole(`æªæ¾å°æ å½¢ä¿¡æ¯æ°æ®å­æ®µã${this.treeInfo.dataField}ã`, 'error');
        }
    }

    getTreeNodeLayer(treeNode: TreeNode) {
        return this.getTreeInfo(treeNode)[this.treeInfo.layerField];
    }
    /** æ´æ°èç¹çå±å¼ç¶æã æ ¹æ®ç»ä»¶ä¸­ expandLevel çå¼å³å®
     * -1ï¼ä¸å±å¼ï¼0ï¼å¨é¨å±å¼ï¼>0 å±å¼å°æå®çº§æ°
     */
    updateTreeNodeExpanded(treeNodes: TreeNode[], treeInfo: TreeInfo = null) {
        if (treeInfo) {
            this.treeInfo = treeInfo;
        } else {
            this.treeInfo = this.instance.treeInfo;
        }
        const expandLevel = this.instance.expandLevel;
        if (expandLevel === -1) {
            return;
        }
        if (!this.flatAllNodes.length) {
            this.flatAllNodes = this.treeData2Flat(null, treeNodes, 0, []);
        }

        treeNodes.forEach((tn: TreeNode) => {
            tn.expanded = this.shoudExpand(expandLevel, this.getTreeNodeLayer(tn));
            if (this.isSelectNodeParent(tn)) {
                tn.expanded = true;
            }
            if (tn.children && tn.children.length) {
                this.updateTreeNodeExpanded(tn.children, treeInfo);
            } else {
                tn.leaf = true;
            }
        });
    }

    private treeData2Flat(parent, nodes, level, parentIds) {
        const idField = this.instance.idField;
        let arr = [];
        if (nodes && nodes.length) {

            nodes.forEach((node, index) => {
                // node.parent = parent;

                let parents = [];
                if (parent) {
                    const parentID = parent.data[idField];
                    const _parents = parentIds || [];
                    parents = parents.concat(_parents.map(n => n));
                    parents.push(parentID);
                }
                const rowNode = {
                    id: node.data[idField],
                    node,
                    level,
                    parents,
                };
                arr.push(rowNode);
                arr = arr.concat(this.treeData2Flat(node, node.children, level + 1, parents));
            });
        }
        return arr;
    }

    private shoudExpand(expandLevel: number, nodeLayer: number) {
        if (expandLevel === -1) {
            // -1 ä¸ºä¸å±å¼
            return false;
        } else if (expandLevel === 0) {
            // 0 ä¸ºå¨é¨å±å¼
            return true;
        } else {
            // æ²¡æå¯ç¨åå±å è½½ï¼éè¿å±å¼å±çº§ç¡®å®æ¯å¦å±å¼è¯¥èç¹
            return nodeLayer <= expandLevel;
        }
    }

    private isSelectNodeParent(treeNode) {
        if (this.instance.navSelectedIds) {
            const allParentIds: string[] = this.flatAllNodes.find(f => f.id === this.instance.navSelectedIds).parents;
            if (allParentIds && allParentIds.length) {
                return allParentIds.includes(treeNode.id);
            }
            return false;
        }
        return false;
    }

    getLeafNode(treeNode: TreeNode) {
        if (treeNode && (!treeNode.children || !treeNode.children.length)) {
            return treeNode;
        } else {
            if (treeNode.children.length === 1) {
                return this.getLeafNode(treeNode.children[0]);
            } else {
                return treeNode.children;
            }
        }
    }

    flatTreeNodes(items, result = []) {
        items = items || [];
        return  items.reduce((c, n) => {
            c.push(n);
            if (n.children && n.children.length) {
                this.flatTreeNodes(n.children, c);
            }
            return c;
        }, result);
    }
}
